import { useCallback, useState } from "react";
import { $POST, UPLOAD_HEADER } from "../../../../api";
import Router from "../../../../const/router";
// Helpers
import resetForm from "../../../../helpers/resetForm";

const AdminWorksUploadForm = () => {
  const [file, setFile] = useState(null);
  const [id, setId] = useState("");

  const uploadFile = useCallback((e) => {
    setFile(e.target.files[0]);
  }, []);

  const submitForm = useCallback(
    async (e) => {
      e.preventDefault();
      try {
        console.groupEnd();
        const formData = new FormData();
        formData.append("image", file);
        await $POST(`${Router.WORKS_UPLOAD}/${id}`, formData, UPLOAD_HEADER);
        resetForm([setId]);
        setFile(null);
      } catch (err) {
        throw new Error(err.message);
      }
    },
    [file, id]
  );

  return (
    <form className="admin-form" onSubmit={submitForm}>
      <h1 className="section-mention">Work Upload</h1>
      <hr className="section-hr" />
      <div className="admin-form-fields">
        <input type="file" onChange={uploadFile} />
        <input
          value={id}
          onChange={(e) => setId(e.target.value)}
          className="upload-id"
          type="text"
          placeholder="ID"
        />
      </div>
      <button>Upload</button>
    </form>
  );
};

export default AdminWorksUploadForm;
